import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "md:container m-0 md:mx-auto pt-5 pb-24"
}
const _hoisted_2 = { class: "overflow-hidden mb-8 w-full bg-white rounded shadow" }
const _hoisted_3 = { class: "flex flex-row overflow-x-scroll" }
const _hoisted_4 = { class: "flex justify-between p-4 text-white bg-black" }
const _hoisted_5 = { class: "flex items-center space-x-3" }
const _hoisted_6 = { class: "p-badge" }
const _hoisted_7 = {
  key: 0,
  class: "p-badge"
}
const _hoisted_8 = {
  key: 1,
  class: "p-badge"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center space-x-2" }, null, -1)
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = { class: "flex items-center py-4 text-3xl" }
const _hoisted_12 = { class: "mb-8 w-5/6" }
const _hoisted_13 = { class: "overflow-hidden p-4 mb-8 w-full bg-white rounded shadow" }
const _hoisted_14 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2" }
const _hoisted_15 = { class: "overflow-hidden p-4 mb-8 w-full bg-white rounded shadow" }
const _hoisted_16 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_image = _resolveComponent("b-image")!
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_performer_property = _resolveComponent("performer-property")!
  const _component_performer_alias = _resolveComponent("performer-alias")!
  const _component_performer_scene_list = _resolveComponent("performer-scene-list")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    loading: _ctx.$apollo.loading
  }, {
    default: _withCtx(() => [
      (_ctx._performer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._performer.posters, (media) => {
                  return (_openBlock(), _createBlock(_component_b_image, {
                    key: `media-${media.uuid}`,
                    class: "carousel-item h-96 w-auto",
                    preset: "posterSmall",
                    src: media.url,
                    alt: _ctx._performer.name
                  }, null, 8, ["src", "alt"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_b_icon, {
                      icon: _ctx._performer.genderIcon,
                      inline: ""
                    }, null, 8, ["icon"])
                  ]),
                  (_ctx._performer.nationality)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createVNode(_component_b_icon, {
                          icon: _ctx._performer.flagIcon,
                          inline: ""
                        }, null, 8, ["icon"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx._performer.birthday)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx._performer.birthdate) + " " + _toDisplayString(_ctx._performer.age ? `(${_ctx._performer.age})` : null), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx._performer.name), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx._performer.bio), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_performer_property, {
                  name: "TPDB ID",
                  value: _ctx._performer.uuid
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Gender",
                  value: _ctx._performer.gender
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Birthday",
                  value: `${_ctx._performer.birthdate} (${_ctx._performer.age})`
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Astrology",
                  value: _ctx._performer.astrology
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Birthplace",
                  value: _ctx._performer.birthplace
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Ethnicity",
                  value: _ctx._performer.ethnicity
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Nationality",
                  value: _ctx._performer.nationality
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Cupsize",
                  value: _ctx._performer.cupsize
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Hair Colour",
                  value: _ctx._performer.hair_colour
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Height",
                  value: _ctx._performer.height
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Weight",
                  value: _ctx._performer.weight
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Measurements",
                  value: _ctx._performer.measurements
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Tattoos",
                  value: _ctx._performer.tattoos
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Piercings",
                  value: _ctx._performer.piercings
                }, null, 8, ["value"]),
                _createVNode(_component_performer_property, {
                  name: "Added",
                  value: _ctx.createdAt
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._performer.performerSites, (performerAlias) => {
                  return (_openBlock(), _createBlock(_component_performer_alias, {
                    key: `alias-${performerAlias.id}`,
                    performer: performerAlias
                  }, null, 8, ["performer"]))
                }), 128))
              ])
            ]),
            (_ctx.performer)
              ? (_openBlock(), _createBlock(_component_performer_scene_list, {
                  key: 0,
                  performer: _ctx._performer
                }, null, 8, ["performer"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}